import { saveAs } from 'file-saver';
import { format } from 'date-fns';
import { FundAllocation } from '../index';
import { transformFundAllocationsToSpreadsheetData } from './transform-fund-allocations-to-spreadsheet-data';
import { buildShareholdingAllocationsSpreadsheet } from 'further-ui/utils';

const downloadAllocationFile = async (
  formFundAllocations: Array<FundAllocation>,
  companyName: string,
  shareClass: string,
) => {
  try {
    const spreadsheetData =
      transformFundAllocationsToSpreadsheetData(formFundAllocations);

    // Get company details from the first allocation
    const firstAllocation = formFundAllocations[0];
    if (!firstAllocation) {
      console.error('No fund allocations provided');
      return;
    }

    const workbook = await buildShareholdingAllocationsSpreadsheet(
      companyName,
      shareClass,
      firstAllocation.dealSharePrice,
      format(firstAllocation.allocationDate.toUTCDate(), 'dd/MM/yyyy'),
      spreadsheetData,
    );

    // Generate and download the file
    const buffer = await workbook.xlsx.writeBuffer();

    // Generate a random number string
    const randomString = Math.floor(Math.random() * 1000000).toString();

    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `Allocation-edit-${companyName}-${randomString}.xlsx`,
    );
  } catch (error) {
    console.error('Error generating spreadsheet:', error);
  }
};

export default downloadAllocationFile;
